import React from 'react';
import styled from 'styled-components';

interface ModalProps {
  isShow: boolean;
  onContinue: () => void;
  onLogout: () => void;
  counter: any;
}

const Overlay = styled.div<{ isShow: boolean }>`
  display: ${({ isShow }) => (isShow ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
`;

const ModalBody = styled.div`
  width: fit-content;
`;

const ModalContainer = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  width: 400px;
`;

const ModalTitle = styled.h3`
  font-weight: 600;
  font-size: 24px;
`;
const ModalText = styled.p`
  .counter {
    font-weight: 500;
  }
`;

const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 0.5rem;
  margin-top: 6rem;
`;

const ButtonIamHere = styled.button`
  font-family: 'Nunito', sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 14px;
  color: #ffffff;
  background: #5b21b6;
  box-sizing: border-box;
  border-radius: 4px;
  border: solid 1px #5b21b6;
  padding: 0.5rem 1rem;
  cursor: pointer;
`;

const ButtonCloseSession = styled.button`
  font-family: 'Nunito', sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 14px;
  color: #36393d;
  background: #ffffff;
  box-sizing: border-box;

  border-radius: 4px;
  border: solid 1px #284fae;
  color: #284fae;
  padding: 0.5rem 1rem;
  cursor: pointer;
`;

const Modal: React.FC<ModalProps> = ({
  isShow,
  onContinue,
  onLogout,
  counter,
}) => {
  return (
    <Overlay isShow={isShow}>
      <ModalContainer>
        <ModalBody>
          <ModalTitle>Aun esta utilizando la pagina?</ModalTitle>
          <ModalText>
            Si no? la sesión se cerrará la sesión en:{' '}
            <span className="counter">00:{counter}</span>
          </ModalText>
        </ModalBody>
        <ModalFooter>
          <ButtonIamHere onClick={onContinue}>Si, estoy aquí</ButtonIamHere>
          <ButtonCloseSession onClick={onLogout}>
            Cerrar sesión
          </ButtonCloseSession>
        </ModalFooter>
      </ModalContainer>
    </Overlay>
  );
};

export default Modal;
